import Candidate from "@mpa/toolbox/models/Candidate";
import type { PartyInfo } from "@mpa/toolbox/models/Party";

import { PromiseToast } from "../../components/async/PromiseToast";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import { callOutgoingRequest, useOutgoingRequest } from "../../data/tanstack-query";
import { getCandidate, updateCandidate } from "../../endpoints/outgoing-requests";
import useSubmit from "../../hooks/useSubmit";
import { usePathParams } from "../../navigation/hooks";
import { goBack } from "../../navigation/location";
import { PartyEditor } from "./components/PartyEditor";
import { candidateRoute } from "./navigation";

export default function CandidatePage() {
    const { user: id } = usePathParams(candidateRoute);
    const candidate = useOutgoingRequest(getCandidate(id));
    const [onEditorDone, edition] = useSubmit(
        async (infos: PartyInfo[]) => {
            const next = new Candidate();
            next.id = candidate.id;
            next.createdAt = candidate.createdAt;
            next.infos = infos;
            await callOutgoingRequest(updateCandidate(id, next));
            goBack();
        },
        [id, candidate],
    );
    return (
        <LightPageLayout>
            <PromiseToast promise={edition} message="Membre modifié" />
            <PageHeader title="Membre de la famille" />
            <PartyEditor infos={candidate.infos} onDone={onEditorDone} />
        </LightPageLayout>
    );
}
